"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Select;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _SelectT = _interopRequireDefault(require("./SelectT"));
function Select(props) {
  const toString = option => option;
  return /*#__PURE__*/_react.default.createElement(_SelectT.default, Object.assign({}, props, {
    isEqual: (A, B) => A === B,
    renderOption: toString,
    toT: toString,
    displayLabel: option => option || ''
  }));
}